var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.logData
    ? _c("div", { staticClass: "delivery-log" }, [
        _vm.logData.auditPerson && _vm.sendStatus >= 1010
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("审核信息"),
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "log-item" },
                        [
                          _c("span", { staticClass: "log-label" }, [
                            _vm._v("审核结果："),
                          ]),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  _vm.logData.auditStep === "1011"
                                    ? "danger"
                                    : "success",
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.logData.auditStep === "1011"
                                    ? "驳回"
                                    : "同意"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("审核人："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.auditPerson || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("审核时间："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.auditTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("审核意见："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.auditOpinion || "-")),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.logData.reservePerson ||
        _vm.logData.reserveTime ||
        _vm.sendStatus === 10 ||
        (_vm.logData.exceptionList && _vm.logData.exceptionList.length)
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("预约信息"),
                ]),
                _vm._v(" "),
                !_vm.logData.reserveTime
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("预约倒计时："),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "countdown-text",
                                staticStyle: { color: "#F56C6C" },
                              },
                              [_vm._v(_vm._s(_vm.reserveCountdownText))]
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.logData.reserveTime
                  ? _c(
                      "el-row",
                      {
                        staticStyle: { display: "flex", "flex-wrap": "wrap" },
                        attrs: { gutter: 20 },
                      },
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              flex: "0 0 20%",
                              "max-width": "20%",
                            },
                            attrs: { span: 24 },
                          },
                          [
                            _c("div", { staticClass: "log-item" }, [
                              _c("span", { staticClass: "log-label" }, [
                                _vm._v("预约人："),
                              ]),
                              _vm._v(_vm._s(_vm.logData.reservePerson || "-")),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.logData.reservePhoto &&
                        _vm.logData.reservePhoto.length > 0
                          ? _c(
                              "el-col",
                              {
                                staticStyle: {
                                  flex: "0 0 20%",
                                  "max-width": "20%",
                                },
                                attrs: { span: 24 },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "log-item",
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "flex-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "log-label",
                                        staticStyle: {
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [_vm._v("预约图片：")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                          gap: "4px",
                                          "margin-left": "4px",
                                        },
                                      },
                                      _vm._l(
                                        _vm.logData.reservePhoto,
                                        function (img, idx) {
                                          return _c("el-image", {
                                            key: idx,
                                            staticStyle: {
                                              width: "50px",
                                              height: "50px",
                                              "border-radius": "4px",
                                            },
                                            attrs: {
                                              src: img.url,
                                              "preview-src-list":
                                                _vm.logData.reservePhoto.map(
                                                  function (i) {
                                                    return i.url
                                                  }
                                                ),
                                              fit: "cover",
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.logData.reserveRemark
                          ? _c(
                              "el-col",
                              {
                                staticStyle: {
                                  flex: "0 0 20%",
                                  "max-width": "20%",
                                },
                                attrs: { span: 24 },
                              },
                              [
                                _c("div", { staticClass: "log-item" }, [
                                  _c("span", { staticClass: "log-label" }, [
                                    _vm._v("预约备注："),
                                  ]),
                                  _vm._v(_vm._s(_vm.logData.reserveRemark)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              flex: "0 0 20%",
                              "max-width": "20%",
                            },
                            attrs: { span: 24 },
                          },
                          [
                            _c("div", { staticClass: "log-item" }, [
                              _c("span", { staticClass: "log-label" }, [
                                _vm._v("预约时间："),
                              ]),
                              _vm._v(_vm._s(_vm.logData.reserveTime || "-")),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              flex: "0 0 20%",
                              "max-width": "20%",
                            },
                            attrs: { span: 24 },
                          },
                          [
                            _c("div", { staticClass: "log-item" }, [
                              _c("span", { staticClass: "log-label" }, [
                                _vm._v("预约及时性："),
                              ]),
                              _vm._v(
                                _vm._s(_vm.logData.reserveTimeliness || "-")
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.logData.exceptionList && _vm.logData.exceptionList.length
                  ? [
                      _vm.logData.reserveTime || _vm.sendStatus === 10
                        ? _c("el-divider")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.logData.exceptionList, function (ex, exIdx) {
                        return _c(
                          "div",
                          { key: exIdx },
                          [
                            exIdx > 0 ? _c("el-divider") : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-wrap": "wrap",
                                },
                                attrs: { gutter: 20 },
                              },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      flex: "0 0 20%",
                                      "max-width": "20%",
                                    },
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("div", { staticClass: "log-item" }, [
                                      _c("span", { staticClass: "log-label" }, [
                                        _vm._v("预约人："),
                                      ]),
                                      _vm._v(_vm._s(ex.person || "-")),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                ex.photo && ex.photo.length
                                  ? _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          flex: "0 0 20%",
                                          "max-width": "20%",
                                        },
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "log-item",
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "log-label",
                                                staticStyle: {
                                                  "white-space": "nowrap",
                                                },
                                              },
                                              [_vm._v("预约异常图片：")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-wrap": "wrap",
                                                  gap: "4px",
                                                  "margin-left": "4px",
                                                },
                                              },
                                              _vm._l(
                                                ex.photo,
                                                function (img, idx) {
                                                  return _c("el-image", {
                                                    key: idx,
                                                    staticStyle: {
                                                      width: "50px",
                                                      height: "50px",
                                                      "border-radius": "4px",
                                                    },
                                                    attrs: {
                                                      src: img.url,
                                                      "preview-src-list":
                                                        ex.photo.map(function (
                                                          i
                                                        ) {
                                                          return i.url
                                                        }),
                                                      fit: "cover",
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      flex: "0 0 20%",
                                      "max-width": "20%",
                                    },
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("div", { staticClass: "log-item" }, [
                                      _c("span", { staticClass: "log-label" }, [
                                        _vm._v("预约异常原因："),
                                      ]),
                                      _vm._v(_vm._s(ex.remark || "-")),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      flex: "0 0 20%",
                                      "max-width": "20%",
                                    },
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("div", { staticClass: "log-item" }, [
                                      _c("span", { staticClass: "log-label" }, [
                                        _vm._v("预约异常时间："),
                                      ]),
                                      _vm._v(_vm._s(ex.time || "-")),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.logData.loadingPerson ||
        _vm.logData.departureTime ||
        _vm.sendStatus === 20
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("出发信息"),
                ]),
                _vm._v(" "),
                _vm.sendStatus === 20 && !_vm.logData.departureTime
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("上门倒计时："),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "countdown-text",
                                style: {
                                  color:
                                    _vm.departCountdownText === "已超时"
                                      ? "#F56C6C"
                                      : "#409EFF",
                                },
                              },
                              [_vm._v(_vm._s(_vm.departCountdownText))]
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.logData.departureTime
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("装车人："),
                            ]),
                            _vm._v(_vm._s(_vm.logData.loadingPerson || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("出发时间："),
                            ]),
                            _vm._v(_vm._s(_vm.logData.departureTime || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-item",
                              staticStyle: {
                                display: "flex",
                                "align-items": "flex-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "log-label",
                                  staticStyle: { "white-space": "nowrap" },
                                },
                                [_vm._v("装车完成图：")]
                              ),
                              _vm._v(" "),
                              _vm.logData.loadingPhoto &&
                              _vm.logData.loadingPhoto.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-wrap": "wrap",
                                        gap: "4px",
                                        "margin-left": "4px",
                                      },
                                    },
                                    _vm._l(
                                      _vm.logData.loadingPhoto,
                                      function (img, idx) {
                                        return _c("el-image", {
                                          key: idx,
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            src: img.url,
                                            "preview-src-list":
                                              _vm.logData.loadingPhoto.map(
                                                function (i) {
                                                  return i.url
                                                }
                                              ),
                                            fit: "cover",
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "margin-left": "4px" } },
                                    [_vm._v("-")]
                                  ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.logData.checkInPerson || _vm.logData.checkInTime
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("到达信息"),
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("签到人："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.checkInPerson || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("签到时间："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.checkInTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("到达及时性："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.arrivalTimeliness || "-")),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.logData.checkInAnomaly
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            { staticClass: "log-item" },
                            [
                              _c("span", { staticClass: "log-label" }, [
                                _vm._v("签到状态："),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                { attrs: { type: "danger", size: "small" } },
                                [_vm._v("打卡异常")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("异常原因："),
                            ]),
                            _vm._v(
                              _vm._s(_vm.logData.checkInAnomalyRemark || "-") +
                                "\n        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            { staticClass: "log-item" },
                            [
                              _vm.logData.checkInAnomalyPhoto &&
                              _vm.logData.checkInAnomalyPhoto.length > 0
                                ? [
                                    _c("span", { staticClass: "log-label" }, [
                                      _vm._v("异常图片："),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.logData.checkInAnomalyPhoto,
                                      function (img, idx) {
                                        return _c("el-image", {
                                          key: idx,
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                            "border-radius": "4px",
                                            "vertical-align": "middle",
                                          },
                                          attrs: {
                                            src: img.url,
                                            "preview-src-list":
                                              _vm.logData.checkInAnomalyPhoto.map(
                                                function (i) {
                                                  return i.url
                                                }
                                              ),
                                            fit: "cover",
                                          },
                                        })
                                      }
                                    ),
                                  ]
                                : _c("span", [_vm._v("-")]),
                            ],
                            2
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.logData.deliverPerson || _vm.logData.deliverTime
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("送达信息"),
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("送达人："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.deliverPerson || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("送达时间："),
                        ]),
                        _vm._v(_vm._s(_vm.logData.deliverTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("送达件数："),
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm.logData.deliverPackageCount != null
                              ? _vm.logData.deliverPackageCount
                              : "-"
                          )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "log-item",
                          staticStyle: {
                            display: "flex",
                            "align-items": "flex-start",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "log-label",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [_vm._v("现场检查图：")]
                          ),
                          _vm._v(" "),
                          _vm.logData.siteCheckPhoto &&
                          _vm.logData.siteCheckPhoto.length > 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-wrap": "wrap",
                                    gap: "4px",
                                    "margin-left": "4px",
                                  },
                                },
                                _vm._l(
                                  _vm.logData.siteCheckPhoto,
                                  function (img, idx) {
                                    return _c("el-image", {
                                      key: idx,
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src: img.url,
                                        "preview-src-list":
                                          _vm.logData.siteCheckPhoto.map(
                                            function (i) {
                                              return i.url
                                            }
                                          ),
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _c(
                                "span",
                                { staticStyle: { "margin-left": "4px" } },
                                [_vm._v("-")]
                              ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "log-item",
                          staticStyle: {
                            display: "flex",
                            "align-items": "flex-start",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "log-label",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [_vm._v("送货完成图：")]
                          ),
                          _vm._v(" "),
                          _vm.logData.deliveryCompletePhoto &&
                          _vm.logData.deliveryCompletePhoto.length > 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-wrap": "wrap",
                                    gap: "4px",
                                    "margin-left": "4px",
                                  },
                                },
                                _vm._l(
                                  _vm.logData.deliveryCompletePhoto,
                                  function (img, idx) {
                                    return _c("el-image", {
                                      key: idx,
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src: img.url,
                                        "preview-src-list":
                                          _vm.logData.deliveryCompletePhoto.map(
                                            function (i) {
                                              return i.url
                                            }
                                          ),
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _c(
                                "span",
                                { staticStyle: { "margin-left": "4px" } },
                                [_vm._v("-")]
                              ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "log-item",
                          staticStyle: {
                            display: "flex",
                            "align-items": "flex-start",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "log-label",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [_vm._v("送货单：")]
                          ),
                          _vm._v(" "),
                          _vm.logData.deliveryOrderPhoto &&
                          _vm.logData.deliveryOrderPhoto.length > 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-wrap": "wrap",
                                    gap: "4px",
                                    "margin-left": "4px",
                                  },
                                },
                                _vm._l(
                                  _vm.logData.deliveryOrderPhoto,
                                  function (img, idx) {
                                    return _c("el-image", {
                                      key: idx,
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src: img.url,
                                        "preview-src-list":
                                          _vm.logData.deliveryOrderPhoto.map(
                                            function (i) {
                                              return i.url
                                            }
                                          ),
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _c(
                                "span",
                                { staticStyle: { "margin-left": "4px" } },
                                [_vm._v("-")]
                              ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-label" }, [
                          _vm._v("现场检查视频："),
                        ]),
                        _vm._v(" "),
                        _vm.logData.siteCheckVideo &&
                        _vm.logData.siteCheckVideo.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-wrap": "wrap",
                                  gap: "8px",
                                  "margin-top": "8px",
                                },
                              },
                              _vm._l(
                                _vm.logData.siteCheckVideo,
                                function (video, idx) {
                                  return _c("div", { key: idx }, [
                                    _c("video", {
                                      staticStyle: {
                                        width: "160px",
                                        height: "90px",
                                        "border-radius": "4px",
                                      },
                                      attrs: { src: video.url, controls: "" },
                                    }),
                                  ])
                                }
                              ),
                              0
                            )
                          : _c("span", [_vm._v("-")]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasLargeFurniture === "需要安装" &&
        _vm.logData.installPhoto &&
        _vm.logData.installPhoto.length > 0
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("大家居安装"),
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "log-item",
                          staticStyle: {
                            display: "flex",
                            "align-items": "flex-start",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "log-label",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [_vm._v("安装完成图：")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                                gap: "4px",
                                "margin-left": "4px",
                              },
                            },
                            _vm._l(
                              _vm.logData.installPhoto,
                              function (img, idx) {
                                return _c("el-image", {
                                  key: idx,
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    "border-radius": "4px",
                                  },
                                  attrs: {
                                    src: img.url,
                                    "preview-src-list":
                                      _vm.logData.installPhoto.map(function (
                                        i
                                      ) {
                                        return i.url
                                      }),
                                    fit: "cover",
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.sendStatus === 50 || _vm.sendStatus === 60
          ? _c(
              "div",
              { staticClass: "log-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("核算信息"),
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-top": "16px",
                      "font-size": "14px",
                    },
                    attrs: {
                      data: _vm.contractList,
                      "header-cell-style": {
                        backgroundColor: "#e8eaed",
                        color: "#333",
                        fontSize: "14px",
                      },
                      border: "",
                      "row-key": "id",
                      "show-summary": "",
                      "summary-method": _vm.getAccountingSummary,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "contractNo",
                        label: "合同号",
                        "min-width": "140",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "productionOrder",
                        label: "订单号",
                        "min-width": "160",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "solutionName",
                        label: "产品名称",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "packages",
                        label: "总包数",
                        "min-width": "80",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "入库数",
                        "min-width": "80",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.inPackages != null
                                        ? scope.row.inPackages
                                        : "-"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3477781353
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "area",
                        label: "面积",
                        "min-width": "80",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "体积",
                        "min-width": "80",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.vol != null
                                        ? scope.row.vol
                                        : "-"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1840844585
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "送货提成",
                        "min-width": "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.sendStatus === 50
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                        type: "number",
                                        min: 0,
                                      },
                                      on: {
                                        change: function (v) {
                                          if (v < 0 || v === "") {
                                            scope.row.deliveryCommission = null
                                          }
                                        },
                                      },
                                      model: {
                                        value: scope.row.deliveryCommission,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "deliveryCommission",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "scope.row.deliveryCommission",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.deliveryCommission != null
                                            ? scope.row.deliveryCommission
                                            : "-"
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3324380094
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "大家居安装提成",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.sendStatus === 50
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                        type: "number",
                                        min: 0,
                                      },
                                      on: {
                                        change: function (v) {
                                          if (v < 0 || v === "") {
                                            scope.row.bigHomeInstallCommission =
                                              null
                                          }
                                        },
                                      },
                                      model: {
                                        value:
                                          scope.row.bigHomeInstallCommission,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "bigHomeInstallCommission",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "scope.row.bigHomeInstallCommission",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.bigHomeInstallCommission !=
                                            null
                                            ? scope.row.bigHomeInstallCommission
                                            : "-"
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1505952638
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "扛楼层数",
                        "min-width": "90",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.sendStatus === 50
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                        type: "number",
                                        min: 0,
                                      },
                                      on: {
                                        change: function (v) {
                                          if (v < 0 || v === "") {
                                            scope.row.floorCount = null
                                          }
                                        },
                                      },
                                      model: {
                                        value: scope.row.floorCount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "floorCount",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "scope.row.floorCount",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.floorCount != null
                                            ? scope.row.floorCount
                                            : "-"
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3315141886
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "扛楼提成",
                        "min-width": "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.sendStatus === 50
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                        type: "number",
                                        min: 0,
                                      },
                                      on: {
                                        change: function (v) {
                                          if (v < 0 || v === "") {
                                            scope.row.floorCommission = null
                                          }
                                        },
                                      },
                                      model: {
                                        value: scope.row.floorCommission,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "floorCommission",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "scope.row.floorCommission",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.floorCommission != null
                                            ? scope.row.floorCommission
                                            : "-"
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4153702398
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "其它提成",
                        "min-width": "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.sendStatus === 50
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                        type: "number",
                                        min: 0,
                                      },
                                      on: {
                                        change: function (v) {
                                          if (v < 0 || v === "") {
                                            scope.row.otherCommission = null
                                          }
                                        },
                                      },
                                      model: {
                                        value: scope.row.otherCommission,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "otherCommission",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "scope.row.otherCommission",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.otherCommission != null
                                            ? scope.row.otherCommission
                                            : "-"
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        789148158
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "核算备注", "min-width": "140" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.sendStatus === 50
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                      },
                                      model: {
                                        value: scope.row.accountingRemark,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "accountingRemark",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.accountingRemark",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.accountingRemark != null
                                            ? scope.row.accountingRemark
                                            : "-"
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        895421483
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.sendStatus === 50
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "16px",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.accountingSubmitting,
                            },
                            on: { click: _vm.handleAccountingSubmit },
                          },
                          [_vm._v("提交")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { loading: _vm.accountingSaving },
                            on: { click: _vm.handleAccountingSave },
                          },
                          [_vm._v("暂存")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }